import { Button, Modal } from 'react-bootstrap';

import { ICaseResolutionPlanStepModel } from '../../../../interfaces/ICaseResolutionModel';
import { LoadingButton } from '../../../../shared/buttons/LoadingButton';
import { useState } from 'react';

interface ICaseResolutionAdvanceModalProps {
    caseResolutionStep: ICaseResolutionPlanStepModel;
    isReject: boolean;
    isSaving: boolean;
    onHide: () => void;
    onContinue: () => void;
    onReject: () => void;
    open: boolean;
}

export function CaseResolutionAdvanceModal({
    caseResolutionStep,
    isReject,
    isSaving,
    onHide,
    onContinue,
    onReject,
    open,
}: ICaseResolutionAdvanceModalProps) {
    const [note, setNote] = useState<string>('');

    const handleDescriptionChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        setNote(e.target.value);
    };

    const handleReject = () => {
        onReject();
    };

    const handleContinue = () => {
        caseResolutionStep.stepData.notes = note;
        onContinue();
    };

    const handleCancel = () => {
        onHide();
    };

    return (
        <Modal centered show={open} dialogClassName="official-case-doc-dialog" onHide={onHide}>
            <Modal.Header>
                <Modal.Title>
                    {isReject ? `Reject Draft` : `Mark ${caseResolutionStep.name} completed`}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {!isReject ? ( //For the time being, adding notes to rejects is not handled by the backend
                    <>
                        <label>Notes</label>
                        <div className="form-group mb-2">
                            <textarea
                                className="form-control"
                                rows={8}
                                style={{
                                    textAlign: 'left',
                                    verticalAlign: 'top',
                                }}
                                name="Notes"
                                onChange={handleDescriptionChange}
                                value={note}
                            />
                        </div>
                    </>
                ) : (
                    <div>
                        Do you wish to reject the draft for{' '}
                        <strong>{caseResolutionStep.name}</strong>?
                    </div>
                )}
            </Modal.Body>
            <Modal.Footer>
                {isReject ? (
                    <Button variant="primary" onClick={handleReject}>
                        Reject
                    </Button>
                ) : (
                    <LoadingButton
                        text="Mark Completed"
                        onClick={handleContinue}
                        loading={isSaving}
                        loadingText="Marking Completed"
                        variant="primary"
                    />
                )}
                <button className="btn btn-default" onClick={handleCancel}>
                    Cancel
                </button>
            </Modal.Footer>
        </Modal>
    );
}
